import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetProductNamesQuery from '@/graphql/contracts/getProductNames.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetProductNames, GetProductNamesVariables } from '@/graphql/contracts/_generated_/getProductNames.query';

export function useGetProductNames() {
  const { data, loading } = useQuery<GetProductNames, GetProductNamesVariables>(
    GetProductNamesQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      })
    }
  );

  return {
    productNames: data?.productNames || [],
    isLoadingProductNames: loading
  };
}
